import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  MarketplaceExtendedQuery,
  MarketplaceItemAttribute,
  MarketplaceItemExtended,
  MarketplaceItemMappingAttribute,
  MemberQuery,
  MarketplaceItemAttributeValue,
  ErrorStateService,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'fgbcl-marketplace-attributes',
  templateUrl: './marketplace-attributes.component.html',
  styleUrls: ['./marketplace-attributes.component.scss'],
})
export class MarketplaceAttributesComponent implements OnInit {
  @Input() marketplaceItem: MarketplaceItemExtended;
  @Output() attributeMapping = new EventEmitter<MarketplaceItemMappingAttribute>();
  localisedAttributes: MarketplaceItemAttribute[] | undefined;
  selectedAttributeValue: MarketplaceItemMappingAttribute | undefined;
  ScreenType = ScreenType;
  private _destroyed$ = new Subject<void>();

  constructor(
    public errorService: ErrorStateService,
    private memberQuery: MemberQuery,
    private marketplaceExtendedQuery: MarketplaceExtendedQuery,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    if (this.marketplaceItem.Attributes && this.marketplaceItem.Attributes.length) {
      this.getLocalAttributes();
      this.setupMapping();
    }
  }

  identify(index: number, item: MarketplaceItemAttributeValue) {
    return item.DisplayName;
  }

  private getLocalAttributes() {
    this.memberQuery.userContext$
      .pipe(
        takeUntil(this._destroyed$),
        map((user) => {
          if (user && user.lcid)
            this.localisedAttributes = this.marketplaceExtendedQuery.getLocalisedAttributes(this.marketplaceItem.Id, +user.lcid);
          else this.localisedAttributes = this.marketplaceItem.Attributes;
        })
      )
      .subscribe();
  }
  addStyleBackdrop() {
    this.elementRef.nativeElement.querySelector('.modal-backdrop').style = 'z-index:999;opacity:0.15;';
  }

  onAttributeChange(event: number) {
    this.selectedAttributeValue = this.marketplaceItem.AttributeMappings.find((attr) => attr.AttributeMappingId === +event);
    this._emitMapping(true, this.selectedAttributeValue);
  }

  private setupMapping() {
    this._emitMapping(false);
  }

  private _emitMapping(emit: boolean, selectedMapping?: MarketplaceItemMappingAttribute) {
    let newMapping: MarketplaceItemMappingAttribute | undefined;
    if (emit) newMapping = selectedMapping;
    else {
      newMapping = new MarketplaceItemMappingAttribute();
      newMapping.AvailableStockCount = 0;
      newMapping.StockCount = 0;
    }
    this.attributeMapping.emit(newMapping);
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
